// ════════════════════════════════════════════════════════════════════
// api.js — backend API base + Anthropic proxy helper (extracted from App.js).
// ════════════════════════════════════════════════════════════════════
import { getCurrentSession } from "../data/auth";
import { t } from "./i18n";
import { apiErrorText, API_ERROR_NETWORK_KEY } from "./apiError";

// ── Backend API base — proxies Anthropic via server's API key ────────
// Auto-detect API base depending on where the portal is served from.
// - On netrev.ai: use relative URL (nginx proxies /api/ to localhost:3001 — same origin, no CORS)
// - On the raw IP: hit the backend directly on port 3001
export const API_BASE = (typeof window !== "undefined" && (window.location.hostname === "netrev.ai" || window.location.hostname.endsWith(".netrev.ai")))
  ? ""
  : "http://145.241.221.243:3001";

// Helper: call Anthropic through our backend proxy (auth required).
// A failure throws an Error whose message is ready to show (lib/apiError.js),
// with `status` (0 when no answer came back) and, when the server sent one,
// `code` (`paid_feature`, `fair_use_cap`). The text is read at throw time, so
// it follows the language the user has chosen.
export async function callAnthropic(body) {
  const session = await getCurrentSession();
  if (!session?.access_token) throw new Error("Not signed in");
  let response;
  try {
    response = await fetch(`${API_BASE}/api/anthropic`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${session.access_token}`,
      },
      body: JSON.stringify(body),
    });
  } catch (_) {
    const e = new Error(t(API_ERROR_NETWORK_KEY));
    e.status = 0;
    throw e;
  }
  if (!response.ok) {
    // Our own errors are { error: "text" }: Express's sentences, or a .NET
    // code, which apiErrorText turns into a sentence. Anthropic's, passed
    // through the proxy verbatim, are { error: { type, message } }. A body
    // that isn't JSON (an nginx page) reads as the generic sentence.
    const err = await response.json().catch(() => null);
    const e = new Error(apiErrorText(err, t));
    e.status = response.status;
    if (err && typeof err.code === "string") e.code = err.code;
    throw e;
  }
  return response.json();
}
